<!--
 * @Author: 仙道
 * @Date: 2022-06-20 18:18:04
 * @LastEditTime: 2022-08-28 00:53:35
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/layout.vue
-->
<template>
  <grid-layout
    :col-num="12"
    :is-draggable="draggable"
    :is-resizable="resizable"
    :layout.sync="layout"
    :responsive="responsive"
    :row-height="30"
    :use-css-transforms="true"
  >
    <!-- :vertical-compact="true" -->
    <grid-item
      :h="item.h"
      :i="item.i"
      :key="item.i"
      :static="item.static"
      :w="item.w"
      :x="item.x"
      :y="item.y"
      v-for="(item) in transformationLayout"
    >
      <a-card>
        <component :is="item.components" />
      </a-card>
    </grid-item>
  </grid-layout>
</template>

<script>
  import { GridLayout, GridItem } from "vue-grid-layout"
  // import PanelOne from './PanelOne.vue'
  export default {
    name: 'Workbench',
    components: {
      GridLayout,
      GridItem
    },
    props: {
      layoutData: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        layout: [
          // { "x": 2, "y": 0, "w": 2, "h": 4, "i": "1", static: false },
          // { "x": 4, "y": 0, "w": 2, "h": 5, "i": "2", static: false },

          // { "x": 10, "y": 0, "w": 2, "h": 3, "i": "3", static: false },
        ],
        transformation: {
          0: {
            name: '面板1', conjunctiveIndex: '0', view: 'PanelOne'
          },
          1: {
            name: '面板2', conjunctiveIndex: '1', view: 'PanelTwo'
          },
          2: {
            name: '面板3', conjunctiveIndex: '2', view: 'PanelThree'
          },
          3: {
            name: '面板4', conjunctiveIndex: '3', view: 'PanelFour'
          },
        },
        loading: true,
        transformationLayout: [],
        draggable: true,
        resizable: true,
        responsive: true,
        index: 0
      }
    },
    created () {
      this.layout = this.layoutData
      //this.loadLayout1()
    },
    methods: {
      loadLayout1 () {
        const that = this
        const resultLayout = that.layout.reduce((pre, cur) => {
          cur.components = (resolve) => require([`@/views/workbench/components/${cur.view}.vue`], resolve)
          pre.push(cur)
          return pre
        }, [])
        console.info(JSON.stringify(resultLayout))
        this.transformationLayout = resultLayout

        that.loading = false
      },
      loadLayout () {
        const that = this
        const resultLayout = that.layout.reduce((pre, cur) => {

          pre.push({
            ...cur,
            ...that.transformation[cur.i],
            components: (resolve) => require([`@/views/workbench/components/${that.transformation[cur.i].view}.vue`], resolve),
          })
          return pre
        }, [])
        console.info(JSON.stringify(resultLayout))
        this.transformationLayout = resultLayout

        that.loading = false
      },
      itemTitle (item) {
        let result = item.i;
        if (item.static) {
          result += " - Static";
        }
        return result;
      }
    }
  }
</script>

<style lang="less" scoped>
  .vue-grid-layout {
    // background: #eee;
  }
  .vue-grid-item:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid black;
  }
  .vue-grid-item .resizing {
    opacity: 0.9;
  }
  .vue-grid-item .static {
    background: #cce;
  }
  .vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
  }
  .vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
  }
  .vue-grid-item .minMax {
    font-size: 12px;
  }
  .vue-grid-item .add {
    cursor: pointer;
  }
  .vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
      no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
  }
</style>